import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { RefuseIdentifyComponent } from '../refuse-identify/refuse-identify.component';

@Component({
  selector: 'app-refuse-success',
  templateUrl: './refuse-success.component.html',
  styleUrls: ['./refuse-success.component.scss']
})
export class RefuseSuccessComponent implements OnInit {
  messageString: string
  isNotAttestedUser: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private message: Message,
    private toastr: ToastrService,
    private route: Router,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<RefuseSuccessComponent>,) {
    // Kiểm tra loại tài khoản KCT
    this.isNotAttestedUser = this.commonService.checkEnterpriseAnonymusType()
  }

  ngOnInit() {
    this.messageString = this.commonService.format(
      this.message.getMessage(
        !this.isNotAttestedUser 
          ? 'kyc.refuse_identify_success_message' 
          : 'kyc.refuse_verify_subject_success_message'
      ), this.data.enterpriseName)
  }

  close() {
    this.dialogRef.close();
  }

}
